import {z} from 'zod';
export const meterAggregationSchema = z.object({
    meterType: z.number(),
    allocationUnit: z.string(),
    allocationUnitSortOrder: z.number().nullable(),
    count: z.number(),
    unit: z.number(),
});
export type MeterAggregation = z.infer<typeof meterAggregationSchema>;
export const meterAggregationsSchema = z.array(meterAggregationSchema);
